"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWorkflowRejectionReasons = exports.customsRejectionReasonLabels = exports.demDetRejectionReasonLabels = void 0;
const workflowRejectionReason_enum_1 = require("./workflowRejectionReason.enum");
exports.demDetRejectionReasonLabels = {
    [workflowRejectionReason_enum_1.WorkflowRejectionReason.CustomerAlreadyInformed]: 'Customer already informed',
    [workflowRejectionReason_enum_1.WorkflowRejectionReason.IncorrectDataRates]: 'Incorrect Data - Rates',
    [workflowRejectionReason_enum_1.WorkflowRejectionReason.CustomerWillNotBeChargedFortoHandlingIssue]: 'Customer will not be charged - Forto Handling Issue',
    [workflowRejectionReason_enum_1.WorkflowRejectionReason.IncorrectDataTimestamps]: 'Incorrect Data - Timestamps',
    [workflowRejectionReason_enum_1.WorkflowRejectionReason.CustomerWillNotBeChargedPartnerHandlingIssue]: 'Customer will not be charged - Partner Handling Issue',
    [workflowRejectionReason_enum_1.WorkflowRejectionReason.CommercialDecision]: 'Commercial decision',
    [workflowRejectionReason_enum_1.WorkflowRejectionReason.CustomerWillNotBeChargedOther]: 'Customer will not be charged - Other',
    [workflowRejectionReason_enum_1.WorkflowRejectionReason.Other]: 'Other',
};
exports.customsRejectionReasonLabels = {
    [workflowRejectionReason_enum_1.WorkflowRejectionReason.NonInspectionEvent]: 'Non-inspection event',
    [workflowRejectionReason_enum_1.WorkflowRejectionReason.IncorrectData]: 'Incorrect data',
    [workflowRejectionReason_enum_1.WorkflowRejectionReason.Other]: 'Other',
};
const getWorkflowRejectionReasons = (ruleID) => {
    switch (ruleID) {
        case 'OCR-MOT-02-DEM-05_pre_free_days_exceeded_left_port':
        case 'OCR-MOT-02-DET-05_pre_free_days_exceeded_container_returned':
        case 'OCR-MOT-02-DEM-DET-05_pre_free_days_exceeded_container_returned':
            return exports.demDetRejectionReasonLabels;
        case 'MAC-MOT-02-EV05_customs_exception':
            return exports.customsRejectionReasonLabels;
        default:
            return;
    }
};
exports.getWorkflowRejectionReasons = getWorkflowRejectionReasons;
//# sourceMappingURL=getWorkflowRejectionReasons.js.map